// @flow

import { useEffect } from 'react'
import { useAnalytics } from 'use-analytics'
import { useSelector } from 'react-redux'
import { and } from 'ramda'
import { isNotNilOrEmpty } from 'ramda-adjunct'

import { isGoogleAnalyticsEnabled } from '@alphaott/app-main/models/selectors'

export const useGoogleAnalyticsPageView = (history: any) => {
  const analytics = useAnalytics()

  const isAnalyticsEnabled = useSelector(isGoogleAnalyticsEnabled)

  useEffect(() => {
    if (isAnalyticsEnabled) {
      if (and(isNotNilOrEmpty(analytics), isNotNilOrEmpty(history))) {
        // For the first page load
        analytics.page()

        history.listen(() => {
          analytics.page()
        })
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useGoogleAnalyticsPageView
